import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const labGroupsLabsRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/groups_labs',
  validateSearch: z.object({
    query: z.string().optional(),
    onlyPartners: z.boolean().default(true),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/lab/GroupsLabs/LabGroupsLabsPage/LabGroupsLabsPage').then((d) => d.Route)
);
